import { jsx as _jsx } from "react/jsx-runtime";
import { NitroBrewRemote } from 'components/pages/nitro-brew-remote';
import { ClawNitroBrewListPage } from 'components/organisms/nitro-brew/claw-nitro-brew-list-page';
import { isNitroClawShell } from 'utils/app-shell-mode';
export const NitroBrewIndexPage = ()=>{
    if (isNitroClawShell()) {
        return /*#__PURE__*/ _jsx(ClawNitroBrewListPage, {});
    }
    return /*#__PURE__*/ _jsx(NitroBrewRemote, {});
};
